<template>
  <div>
    <b-row>
      <b-col xl="4" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="RegNum"
          :name="'№ документа'"
          :rules="{ required: true }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-1"
            label="№ документа"
            label-for="input-1"
            :label-class="{ 'form-label': true, 'font-weight-bold': true, 'filled-field': (!!waybillForm.RegNum), 'empty-field': !(!!waybillForm.RegNum) }"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :disabled="notForEdit"
              id="input-1"
              :class="{ 'form-input': true, 'filled-field': (!!waybillForm.RegNum), 'required-field': !(!!waybillForm.RegNum) }"
              v-model="waybillForm.RegNum"
              placeholder="№ документа"
              @change="updateIdbData"
              :state="getValidationState(validationContext)"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="4" lg="6" md="6" sm="6" cols="12">
        <custom-input
          ref="ShipmentType"
          inputId="ShipmentType"
          inputName="Тип перевозки"
          :inputItems="shipmentTypes"
          :targetInput="targetInput"
          :disabled="notForEdit"
          :inputFields="[
             { key: 'value', label: 'Код' },
             { key: 'text', label: 'Тип' }
           ]"
          select="value"
          :loadOnFocus="true"
          :getData="() => { return promise.resolve() }"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <h4 class="form-subtitle">Накладная принята:</h4>
    <b-row>
      <b-col xl="4" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="PersonName"
          name="ФИО"
          :rules="{ required: true }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-3"
            label="ФИО"
            label-for="input-3"
            :label-class="(!!waybillForm.PersonName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-3"
              :class="{ 'form-input': true, 'filled-field': (!!waybillForm.PersonName), 'required-field': !(!!waybillForm.PersonName) }"
              v-model="waybillForm.PersonName"
              placeholder="ФИО"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <custom-datepicker
          ref="RegDate"
          inputId="RegDate"
          inputName="Дата выдачи"
          :disabled="notForEdit"
          :required="true"
          :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/, required: true }"
          @setForm="setModel($event)"
          @updateIdbData="updateIdbData"
        ></custom-datepicker>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <custom-timepicker
          ref="RegTime"
          inputId="RegTime"
          inputName="Время выдачи"
          :disabled="notForEdit"
          :required="true"
          :inputValidationRules="{ regex: /^\d{2}[:]\d{2}$/, required: true }"
          @setForm="setModel($event)"
          @updateIdbData="updateIdbData"
        ></custom-timepicker>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <custom-input
          ref="CustomsModeCode"
          inputId="CustomsModeCode"
          inputName="Таможенный режим"
          :inputValidationRules="{ required: true }"
          :required="true"
          :inputItems="nsiProcedures"
          :targetInput="targetInput"
          :disabled="notForEdit"
          :inputFields="[
            { key: 'code', label: 'Код' },
            { key: 'name', label: 'Наименование' }
          ]"
          query="p"
          :delay="1"
          select="code"
          :loadOnFocus="true"
          :getData="loadNsiProcedures"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <custom-input
          ref="CurrencyCode"
          inputId="CurrencyCode"
          inputName="Код валюты"
          :inputItems="nsiCurrency"
          :inputValidationRules="{ max: 3 }"
          :targetInput="targetInput"
          :disabled="notForEdit"
          :inputFields="[
            { key: 'abbr', label: 'Код' },
            { key: 'name', label: 'Наименование' }
          ]"
          query="p"
          :delay="1"
          select="abbr"
          :getData="loadNsiCurrency"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="GrossWeightTotal"
          :name="'Суммарный вес брутто'"
          v-slot="validationContext">
          <b-form-group
            id="input-group-8"
            label="Суммарный вес брутто"
            label-for="input-8"
            :label-class="{ 'form-label': true, 'font-weight-bold': true, 'filled-field': (!!waybillForm.GrossWeightTotal), 'empty-field': !(!!waybillForm.GrossWeightTotal) }"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :disabled="notForEdit"
              id="input-8"
              :class="{ 'form-input': true, 'filled-field': (!!waybillForm.GrossWeightTotal) }"
              v-model="waybillForm.GrossWeightTotal"
              placeholder="Суммарный вес брутто"
              @change="updateIdbData"
              :state="getValidationState(validationContext)"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="NetWeightTotal"
          :name="'Суммарный вес нетто'"
          :rules="{ max: 35 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-9"
            label="Суммарный вес нетто"
            label-for="input-9"
            :label-class="{ 'form-label': true, 'font-weight-bold': true, 'filled-field': (!!waybillForm.NetWeightTotal), 'empty-field': !(!!waybillForm.NetWeightTotal) }"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :disabled="notForEdit"
              id="input-9"
              :class="{ 'form-input': true, 'filled-field': (!!waybillForm.NetWeightTotal) }"
              v-model="waybillForm.NetWeightTotal"
              placeholder="Суммарный вес нетто"
              @change="updateIdbData"
              :state="getValidationState(validationContext)"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
        <custom-input
          ref="InternationalDistribution"
          inputId="InternationalDistribution"
          inputName="Международная рассылка"
          :inputItems="internationalDistributionTypes"
          :targetInput="targetInput"
          :inputFields="[
             { key: 'value', label: 'Код' },
             { key: 'text', label: 'Тип' }
          ]"
          :inputValidationRules="{required: true }"
          :required="true"
          :getData="() => { return promise.resolve() }"
          :disabled="notForEdit"
          select="value"
          :loadOnFocus="true"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="6" md="6" sm="6" cols="12">
        <validation-provider
          ref="MailStickerNum"
          :name="'Номер наклейки'"
          v-slot="validationContext">
          <b-form-group
            id="input-group-11"
            label="Номер наклейки"
            label-for="input-11"
            :label-class="{ 'form-label': true, 'font-weight-bold': true, 'filled-field': (!!waybillForm.MailStickerNum), 'empty-field': !(!!waybillForm.MailStickerNum) }"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              :disabled="notForEdit"
              id="input-11"
              :class="{ 'form-input': true, 'filled-field': (!!waybillForm.MailStickerNum) }"
              v-model="waybillForm.MailStickerNum"
              placeholder="Номер наклейки"
              @change="updateIdbData"
              :state="getValidationState(validationContext)"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <h4 class="form-title">Отправитель</h4>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="Consignor_Name"
          name="Наименование отправителя"
          :rules="{ required: true, max: 150 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-12"
            label="Наименование отправителя"
            label-for="input-12"
            :label-class="(!!waybillForm.Consignor_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-12"
              :class="{ 'form-input': true, 'filled-field': (!!waybillForm.Consignor_Name), 'required-field': !(!!waybillForm.Consignor_Name) }"
              v-model="waybillForm.Consignor_Name"
              placeholder="Наименование отправителя"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Consignor_Name"
            :name="'ИНН отправителя'"
            :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-13"
              label="ИНН"
              label-for="input-13"
              :label-class="(!!waybillForm.Consignor_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-13"
                :class="(!!waybillForm.Consignor_INN) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Consignor_INN"
                placeholder="ИНН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Consignor_KPP"
            :name="'КПП отправителя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-14"
              label="КПП"
              label-for="input-14"
              :label-class="(!!waybillForm.Consignor_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-14"
                :class="(!!waybillForm.Consignor_KPP) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Consignor_KPP"
                placeholder="КПП"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Consignor_OGRN"
            :name="'ОГРН отправителя'"
            :rules="{ max: 15, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-15"
              label="ОГРН"
              label-for="input-15"
              :label-class="(!!waybillForm.Consignor_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-15"
                :class="(!!waybillForm.Consignor_OGRN) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Consignor_OGRN"
                placeholder="ОГРН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="Consignor_CountryCode"
          inputId="Consignor_CountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignor_CountryCode: 'abc2' },
            { Consignor_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="Consignor_CountryName"
          inputId="Consignor_CountryName"
          inputName="Наименование страны отправителя"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignor_CountryCode: 'abc2' },
            { Consignor_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Consignor_PostalCode"
            :name="'Индекс отправителя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-18"
              label="Почтовый индекс"
              label-for="input-18"
              :label-class="(!!waybillForm.Consignor_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-18"
                :class="(!!waybillForm.Consignor_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Consignor_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Consignor_Region"
            inputId="Consignor_Region"
            inputName="Область (регион, штат, провинция и т.п.) отправителя"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 150 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Consignor_City"
            :name="'Населенный пункт отправителя'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-20"
              label="Населенный пункт"
              label-for="input-20"
              :label-class="(!!waybillForm.Consignor_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-20"
                :class="(!!waybillForm.Consignor_City) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Consignor_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Consignor_StreetHouse"
            inputId="Consignor_StreetHouse"
            inputName="Улица, номер дома, номер офиса"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 50 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <h4 class="form-title">Получатель</h4>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="Consignee_Name"
          :name="'Наименование получателя'"
          :rules="{ max: 150, required: true }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-22"
            label="Наименование получателя"
            label-for="input-22"
            :label-class="(!!waybillForm.Consignee_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-22"
              :class="{ 'form-input': true, 'filled-field': (!!waybillForm.Consignee_Name), 'required-field': !(!!waybillForm.Consignee_Name) }"
              v-model="waybillForm.Consignee_Name"
              placeholder="Наименование получателя"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Consignee_INN"
            :name="'ИНН получателя'"
            :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-23"
              label="ИНН"
              label-for="input-23"
              :label-class="(!!waybillForm.Consignee_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-23"
                :class="(!!waybillForm.Consignee_INN) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Consignee_INN"
                placeholder="ИНН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Consignee_KPP"
            :name="'КПП получателя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-24"
              label="КПП"
              label-for="input-24"
              :label-class="(!!waybillForm.Consignee_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-24"
                :class="(!!waybillForm.Consignee_KPP) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Consignee_KPP"
                placeholder="КПП"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Consignee_OGRN"
            :name="'ОГРН отправителя'"
            :rules="{ max: 15, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-25"
              label="ОГРН"
              label-for="input-25"
              :label-class="(!!waybillForm.Consignee_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-25"
                :class="(!!waybillForm.Consignee_OGRN) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Consignee_OGRN"
                placeholder="ОГРН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="Consignee_CountryCode"
          inputId="Consignee_CountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignee_CountryCode: 'abc2' },
            { Consignee_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="Consignee_CountryName"
          inputId="Consignee_CountryName"
          inputName="Наименование страны получателя"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Consignee_CountryCode: 'abc2' },
            { Consignee_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Consignee_PostalCode"
            :name="'Индекс получателя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-28"
              label="Почтовый индекс"
              label-for="input-28"
              :label-class="(!!waybillForm.Consignee_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-28"
                :class="(!!waybillForm.Consignee_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Consignee_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Consignee_Region"
            inputId="Consignee_Region"
            inputName="Область (регион, штат, провинция и т.п.) получателя"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 150 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Consignee_City"
            :name="'Населенный пункт получателя'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-30"
              label="Населенный пункт"
              label-for="input-30"
              :label-class="(!!waybillForm.Consignee_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-30"
                :class="(!!waybillForm.Consignee_City) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Consignee_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Consignee_StreetHouse"
            inputId="Consignee_StreetHouse"
            inputName="Улица, номер дома, номер офиса"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 50 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <h4 class="form-subtitle">Документ, удостоверяющий личность</h4>
    <b-row>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <custom-input
          ref="Consignee_IdentityCardCode"
          inputId="Consignee_IdentityCardCode"
          inputName="Код вида документа"
          :inputItems="nsiIdentityDocuments"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'code', label: 'Код' },
            { key: 'abbr', label: 'Аббревиатура' },
            { key: 'description', label: 'Наименование' }
          ]"
          :inputRelatedFields="[
            { Consignee_IdentityCardName: 'abbr' },
          ]"
          :getData="loadNsiIdentityDocuments"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="code"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="2" md="6" sm="6" cols="12">
        <custom-input
          ref="Consignee_IdentityCardName"
          inputId="Consignee_IdentityCardName"
          inputName="Краткое наименование"
          :inputItems="nsiIdentityDocuments"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'code', label: 'Код' },
            { key: 'abbr', label: 'Аббревиатура' },
            { key: 'description', label: 'Наименование' }
          ]"
          :inputRelatedFields="[
            { Consignee_IdentityCardCode: 'code' },
          ]"
          :getData="loadNsiIdentityDocuments"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abbr"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="4" md="6" sm="6" cols="12">
        <validation-provider
          ref="consigneeIdentityCardSeries"
          name="Серия документа"
          v-slot="validationContext">
          <b-form-group
            id="input-group-34"
            label="Серия документа"
            label-for="input-34"
            :label-class="(!!waybillForm.Consignee_IdentityCardSeries) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-34"
              :class="(!!waybillForm.Consignee_IdentityCardSeries) ? 'form-input filled-field' : 'form-input'"
              v-model="waybillForm.Consignee_IdentityCardSeries"
              placeholder="Серия документа"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="4" md="6" sm="6" cols="12">
        <validation-provider
          ref="consigneeIdentityCardNumber"
          name="Номер документа"
          :rules="{ regex: /^\d+$/ }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-35"
            label="Номер документа"
            label-for="input-35"
            :label-class="(!!waybillForm.Consignee_IdentityCardNumber) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-35"
              :class="(!!waybillForm.Consignee_IdentityCardNumber) ? 'form-input filled-field' : 'form-input'"
              v-model="waybillForm.Consignee_IdentityCardNumber"
              placeholder="Номер документа"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-datepicker
          ref="Consignee_IdentityCardDate"
          inputId="Consignee_IdentityCardDate"
          inputName="Дата выдачи"
          :disabled="notForEdit"
          :inputValidationRules="{ regex: /^\d{2}[.]\d{2}[.]\d{4}?$/ }"
          @setForm="setModel($event)"
          @updateIdbData="updateIdbData"
        ></custom-datepicker>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <validation-provider
          ref="Consignee_IdentityCardOrgName"
          name="Наименование организации, выдавшей документ"
          :rules="{ max: 50 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-37"
            label="Организация, выдавшая документ"
            label-for="input-37"
            :label-class="(!!waybillForm.Consignee_IdentityCardOrgName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-37"
              :class="(!!waybillForm.Consignee_IdentityCardOrgName) ? 'form-input filled-field' : 'form-input'"
              v-model="waybillForm.Consignee_IdentityCardOrgName"
              placeholder="Организация, выдавшая документ"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <h4 class="form-title">Перевозчик</h4>
    <b-row>
      <b-col xl="4" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="Carrier_Name"
          name="Наименование"
          :rules="{ required: true, max: 150 }"
          v-slot="validationContext">
          <b-form-group
            id="input-group-38"
            label="Наименование"
            label-for="input-38"
            :label-class="(!!waybillForm.Carrier_Name) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-38"
              :class="{ 'form-input': true, 'filled-field': (!!waybillForm.Carrier_Name), 'required-field': !(!!waybillForm.Carrier_Name) }"
              v-model="waybillForm.Carrier_Name"
              placeholder="Наименование"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
      <b-col xl="2" lg="6" md="6" sm="6" cols="12">
          <validation-provider
            ref="Carrier_INN"
            :name="'ИНН'"
            :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-39"
              label="ИНН"
              label-for="input-39"
              :label-class="(!!waybillForm.Carrier_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-39"
                :class="(!!waybillForm.Carrier_INN) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Carrier_INN"
                placeholder="ИНН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="2" lg="6" md="6" sm="6" cols="12">
          <validation-provider
            ref="Carrier_OKPO"
            :name="'ОКПО'"
            v-slot="validationContext">
            <b-form-group
              id="input-group-40"
              label="ОКПО"
              label-for="input-14"
              :label-class="(!!waybillForm.Carrier_OKPO) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-40"
                :class="(!!waybillForm.Carrier_OKPO) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Carrier_OKPO"
                placeholder="ОКПО"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
    </b-row>
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12">
          <validation-provider
            ref="CustomsBrokerCertificate"
            :name="'№ свидетельства о включении в Реестр таможенных брокеров'"
            :rules="{ required: true, max: 50 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-41"
              label="№ свидетельства о включении в Реестр таможенных брокеров"
              label-for="input-41"
              :label-class="(!!waybillForm.CustomsBrokerCertificate) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-41"
                :class="{ 'form-input': true, 'filled-field': (!!waybillForm.CustomsBrokerCertificate), 'required-field': !(!!waybillForm.CustomsBrokerCertificate) }"
                v-model="waybillForm.CustomsBrokerCertificate"
                placeholder="№ свидетельства о включении в Реестр таможенных брокеров"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
    </b-row>
    <b-row>
        <b-col xl="8" lg="12" md="12" sm="12" cols="12">
          <validation-provider
            ref="Carrier_Note"
            :name="'Дополнительные сведения'"
            v-slot="validationContext">
            <b-form-group
              id="input-group-42"
              label="Дополнительные сведения"
              label-for="input-42"
              :label-class="(!!waybillForm.Carrier_Note) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-42"
                :class="(!!waybillForm.Carrier_Note) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Carrier_Note"
                placeholder="Дополнительные сведения"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
    </b-row>
    <h4 class="form-subtitle">Юридический адрес</h4>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="Carrier_CountryCode"
          inputId="Carrier_CountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Carrier_CountryCode: 'abc2' },
            { Carrier_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="Carrier_CountryName"
          inputId="Carrier_CountryName"
          inputName="Наименование страны"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Carrier_CountryCode: 'abc2' },
            { Carrier_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Carrier_PostalCode"
            :name="'Индекс получателя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-45"
              label="Почтовый индекс"
              label-for="input-45"
              :label-class="(!!waybillForm.Carrier_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-45"
                :class="(!!waybillForm.Carrier_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Carrier_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Carrier_Region"
            inputId="Carrier_Region"
            inputName="Область (регион, штат, провинция и т.п.)"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 150 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Carrier_City"
            :name="'Населенный пункт получателя'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-47"
              label="Населенный пункт"
              label-for="input-47"
              :label-class="(!!waybillForm.Carrier_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-47"
                :class="(!!waybillForm.Carrier_City) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Carrier_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Carrier_StreetHouse"
            inputId="Carrier_StreetHouse"
            inputName="Улица, номер дома, номер офиса"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 50 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <h4 class="form-subtitle">Фактический адрес</h4>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="Carrier_FactCountryCode"
          inputId="Carrier_FactCountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Carrier_FactCountryCode: 'abc2' },
            { Carrier_FactCountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="Carrier_FactCountryName"
          inputId="Carrier_FactCountryName"
          inputName="Наименование страны"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Carrier_FactCountryCode: 'abc2' },
            { Carrier_FactCountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Carrier_FactPostalCode"
            :name="'Индекс получателя'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-28"
              label="Почтовый индекс"
              label-for="input-28"
              :label-class="(!!waybillForm.Carrier_FactPostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-28"
                :class="(!!waybillForm.Carrier_FactPostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Carrier_FactPostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Carrier_FactRegion"
            inputId="Carrier_FactRegion"
            inputName="Область (регион, штат, провинция и т.п.)"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 150 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Carrier_FactCity"
            :name="'Населенный пункт получателя'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-29"
              label="Населенный пункт"
              label-for="input-29"
              :label-class="(!!waybillForm.Carrier_FactCity) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-29"
                :class="(!!waybillForm.Carrier_FactCity) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Carrier_FactCity"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Carrier_FactStreetHouse"
            inputId="Carrier_FactStreetHouse"
            inputName="Улица, номер дома, номер офиса"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 50 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <h4 class="form-title">Пункт отправления</h4>
    <b-row>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="Departure_Name"
          inputId="Departure_Name"
          inputName="Наименование"
          :inputValidationRules="{ max: 80 }"
          :inputItems="nsiAirports"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'iata', label: 'Код' },
            { key: 'name_rus', label: 'Наименование' },
            { key: 'city_rus', label: 'Город' }
          ]"
          :inputRelatedFields="[
            { Departure_IATACode: 'iata' },
          ]"
          :getData="loadNsiAirports"
          :disabled="notForEdit"
          :delay="1"
          query="name"
          select="name_rus"
          :required="true"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="Departure_IATACode"
          inputId="Departure_IATACode"
          inputName="ИАТА"
          :inputValidationRules="{ max: 3 }"
          :inputItems="nsiAirports"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'iata', label: 'Код' },
            { key: 'name_rus', label: 'Наименование' },
            { key: 'city_rus', label: 'Город' }
          ]"
          :inputRelatedFields="[
            { Departure_Name: 'name_rus' },
          ]"
          :getData="loadNsiAirports"
          :disabled="notForEdit"
          :delay="1"
          query="iata"
          select="iata"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
        </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="Departure_CountryCode"
          inputId="Departure_CountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Departure_CountryCode: 'abc2' },
            { Departure_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="Departure_CountryName"
          inputId="Departure_CountryName"
          inputName="Наименование страны"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Departure_CountryCode: 'abc2' },
            { Departure_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Departure_PostalCode"
            :name="'Индекс'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-28"
              label="Почтовый индекс"
              label-for="input-28"
              :label-class="(!!waybillForm.Departure_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-28"
                :class="(!!waybillForm.Departure_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Departure_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Departure_Region"
            inputId="Departure_Region"
            inputName="Область (регион, штат, провинция и т.п.)"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 150 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Departure_City"
            :name="'Населенный пункт'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-29"
              label="Населенный пункт"
              label-for="input-29"
              :label-class="(!!waybillForm.Departure_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-29"
                :class="(!!waybillForm.Departure_City) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Departure_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Departure_StreetHouse"
            inputId="Departure_StreetHouse"
            inputName="Улица, номер дома, номер офиса"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 50 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <h4 class="form-title">Пункт назначения</h4>
    <b-row>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="Delivery_Name"
          inputId="Delivery_Name"
          inputName="Наименование"
          :inputValidationRules="{ max: 80 }"
          :inputItems="nsiAirports"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'iata', label: 'Код' },
            { key: 'name_rus', label: 'Наименование' },
            { key: 'city_rus', label: 'Город' }
          ]"
          :inputRelatedFields="[
            { Delivery_IATACode: 'iata' },
          ]"
          :getData="loadNsiAirports"
          :disabled="notForEdit"
          :delay="1"
          query="name"
          select="name_rus"
          :required="true"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="Delivery_IATACode"
          inputId="Delivery_IATACode"
          inputName="ИАТА"
          :inputValidationRules="{ max: 3 }"
          :inputItems="nsiAirports"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'iata', label: 'Код' },
            { key: 'name_rus', label: 'Наименование' },
            { key: 'city_rus', label: 'Город' }
          ]"
          :inputRelatedFields="[
            { Delivery_Name: 'name_rus' },
          ]"
          :getData="loadNsiAirports"
          :disabled="notForEdit"
          :delay="1"
          query="iata"
          select="iata"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
        </b-col>
    </b-row>
    <b-row>
      <b-col xl="2" lg="4" md="4" sm="4" cols="12">
        <custom-input
          ref="Delivery_CountryCode"
          inputId="Delivery_CountryCode"
          inputName="Буквенный код страны"
          :inputValidationRules="{ max: 2 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Delivery_CountryCode: 'abc2' },
            { Delivery_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="abc2"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
      <b-col xl="6" lg="8" md="8" sm="8" cols="12">
        <custom-input
          ref="Delivery_CountryName"
          inputId="Delivery_CountryName"
          inputName="Наименование страны"
          :inputValidationRules="{ max: 40 }"
          :inputItems="nsiCountries"
          :targetInput="targetInput"
          :inputFields="[
            { key: 'abc2', label: 'Код' },
            { key: 'name', label: 'Страна' }
          ]"
          :inputRelatedFields="[
            { Delivery_CountryCode: 'abc2' },
            { Delivery_CountryName: 'name' }
          ]"
          :getData="loadNsiCountries"
          :disabled="notForEdit"
          :delay="1"
          query="p"
          select="name"
          @setForm="setModel($event)"
          @setRelatedFields="setRelated($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
      </b-col>
    </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Delivery_PostalCode"
            :name="'Индекс'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-28"
              label="Почтовый индекс"
              label-for="input-28"
              :label-class="(!!waybillForm.Delivery_PostalCode) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-28"
                :class="(!!waybillForm.Delivery_PostalCode) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Delivery_PostalCode"
                placeholder="Почтовый индекс"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Delivery_Region"
            inputId="Delivery_Region"
            inputName="Область (регион, штат, провинция и т.п.)"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 150 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Delivery_City"
            :name="'Населенный пункт'"
            :rules="{ max: 35 }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-29"
              label="Населенный пункт"
              label-for="input-29"
              :label-class="(!!waybillForm.Delivery_City) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-29"
                :class="(!!waybillForm.Delivery_City) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Delivery_City"
                placeholder="Населенный пункт"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="6" lg="8" md="8" sm="8" cols="12">
          <custom-input
            ref="Delivery_StreetHouse"
            inputId="Delivery_StreetHouse"
            inputName="Улица, номер дома, номер офиса"
            type="simple"
            :disabled="notForEdit"
            :inputValidationRules="{ max: 50 }"
            :edited="true"
            :required="false"
            @setForm="setModel($event)"
            @setTargetInput="$emit('setTarget', $event)"
            @closeRefs="$emit('closeRefs')"
            @setRefVisible="$emit('setVisible', $event)"
          ></custom-input>
        </b-col>
      </b-row>
    <b-row class="mt-2">
      <b-col xl="8" lg="12" md="12" sm="12" cols="12">
        <b-button class="collapsed" @click="collapseInsuranceVisible = !collapseInsuranceVisible" variant="link">Страхование</b-button>
      </b-col>
    </b-row>
    <b-collapse id="collapse-delivery" v-model="collapseInsuranceVisible" class="pt-3">
    <b-row>
      <b-col xl="8" lg="12" md="12" sm="12" cols="12">
        <validation-provider
          ref="Insurance_OrgName"
          name="Наименование"
          v-slot="validationContext">
          <b-form-group
            id="input-group-15"
            label="Наименование страховой компании"
            label-for="input-15"
            :label-class="(!!waybillForm.Insurance_OrgName) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
            :invalid-feedback="validationContext.errors[0]"
          >
            <b-form-input
              id="input-15"
              :class="{ 'form-input': true, 'filled-field': (!!waybillForm.Insurance_OrgName) }"
              v-model="waybillForm.Insurance_OrgName"
              placeholder="Наименование страховой компании"
              :disabled="notForEdit"
              :state="getValidationState(validationContext)"
              @change="updateIdbData"
              trim
            ></b-form-input>
          </b-form-group>
        </validation-provider>
      </b-col>
    </b-row>
    <b-row>
       <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Insurance_Amount"
            :name="'Сумма страховки'"
            v-slot="validationContext">
            <b-form-group
              id="input-group-14"
              label="Сумма страховки"
              label-for="input-14"
              :label-class="(!!waybillForm.Insurance_Amount) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-14"
                :class="(!!waybillForm.Insurance_Amount) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Insurance_Amount"
                placeholder="Сумма страховки"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Insurance_Account"
            :name="'Номер счёта'"
            v-slot="validationContext">
            <b-form-group
              id="input-group-12"
              label="Номер счёта"
              label-for="input-12"
              :label-class="(!!waybillForm.Insurance_Account) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-12"
                :class="(!!waybillForm.Insurance_Account) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Insurance_Account"
                placeholder="Номер счёта"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <custom-input
          ref="Insurance_PaymentType"
          inputId="Insurance_PaymentType"
          inputName="Вид оплаты"
          :inputItems="insurancePaymentTypes"
          :targetInput="targetInput"
          :disabled="notForEdit"
          :inputFields="[
             { key: 'value', label: 'Код' },
             { key: 'text', label: 'Тип' }
           ]"
          :loadOnFocus="true"
          select="value"
          :getData="() => { return promise.resolve() }"
          @setForm="setModel($event)"
          @setTargetInput="$emit('setTarget', $event)"
          @closeRefs="$emit('closeRefs')"
          @setRefVisible="$emit('setVisible', $event)"
        ></custom-input>
        </b-col>
      </b-row>
    <b-row>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Insurance_INN"
            :name="'ИНН'"
            :rules="{ min: 10, max: 12, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-12"
              label="ИНН"
              label-for="input-12"
              :label-class="(!!waybillForm.Insurance_INN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-12"
                :class="(!!waybillForm.Insurance_INN) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Insurance_INN"
                placeholder="ИНН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="2" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Insurance_KPP"
            :name="'КПП'"
            :rules="{ max: 9, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-13"
              label="КПП"
              label-for="input-13"
              :label-class="(!!waybillForm.Insurance_KPP) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-13"
                :class="(!!waybillForm.Insurance_KPP) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Insurance_KPP"
                placeholder="КПП"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col xl="4" lg="4" md="4" sm="4" cols="12">
          <validation-provider
            ref="Insurance_OGRN"
            :name="'ОГРН'"
            :rules="{ max: 15, regex: /^\d+$/ }"
            v-slot="validationContext">
            <b-form-group
              id="input-group-14"
              label="ОГРН"
              label-for="input-14"
              :label-class="(!!waybillForm.Insurance_OGRN) ? 'form-label font-weight-bold filled-field' : 'form-label font-weight-bold empty-field'"
              :invalid-feedback="validationContext.errors[0]"
            >
              <b-form-input
                id="input-14"
                :class="(!!waybillForm.Insurance_OGRN) ? 'form-input filled-field' : 'form-input'"
                v-model="waybillForm.Insurance_OGRN"
                placeholder="ОГРН"
                :disabled="notForEdit"
                :state="getValidationState(validationContext)"
                @change="updateIdbData"
                trim
              ></b-form-input>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
  import {mapState, mapActions} from 'vuex'
  import CustomInput from '../../CustomInput'
  import CustomDatepicker from '../../CustomDatepicker'
  import CustomTimepicker from '../../CustomTimePicker'
  // import { extend } from 'vee-validate'

  export default {
    name: "WaybillExpressIndividualPage",
    props: ['getValidationState', 'waybill', 'houseShipment', 'targetInput', 'notForEdit'],
    components: {
      CustomInput,
      CustomDatepicker,
      CustomTimepicker
    },
    data () {
      return {
        promise: window.Promise,
        waybillForm: {
            did: null,
            DOC_ID: null,
            RegNum: null,
            ShipmentType: null, //Тип перевозки: 1 - автомобильные перевозки; 2 - перевозки водным транспортом; 3 - авиаперевозки
            PersonName: null,
            RegDate: null,
            RegTime: null,
            CustomsModeCode: null,
            CurrencyCode: null,
            GrossWeightTotal: null,
            NetWeightTotal: null,
            Services: null,
            SpecialServices: null,
            InternationalDistribution: null, //Международная рассылка: 1 - используется, 0 - не используется
            MailStickerNum: null, //Номер наклейки
            Consignor_Name: null, // Отправитель: наименование
            Consignor_Account: null, // Номер счёта
            Consignor_OGRN: null, // Отправитель: ОГРН (для РФ), БИН (для Казахстана)
            Consignor_INN: null, // Отправитель:ИНН (в соответствии с национальной системой кодирования)
            Consignor_KPP: null, // Отправитель: КПП
            Consignor_CountryCode: null, // Отправитель: буквенный код страны
            Consignor_CountryName: null, // Отправитель: наименование страны
            Consignor_PostalCode: null, // Отправитель: почтовый индекс
            Consignor_Region: null, // Отправитель: область (регион, штат, провинция и т.п.)
            Consignor_City: null, // Отправитель: населенный пункт
            Consignor_StreetHouse: null, // Отправитель: улица, номер дома, номер офиса
            Consignor_Notes: null, //Особые отметки
            Consignor_PersonName: null, // Подпись уполномоченного лица: ФИО
            Consignor_PersonName2: null,
            Consignor_PersonMiddleName: null,
            Consignor_PersonPost: null,
            Consignor_IssueDate: null,
            Consignee_Name: null, // Получатель: наименование
            Consignee_Account: null,
            Consignee_CountryCode: null, // Получатель: буквенный код страны
            Consignee_CountryName: null, // Получатель: наименование страны
            Consignee_PostalCode: null, // Получатель: почтовый индекс
            Consignee_Region: null, // Получатель: область (регион, штат, провинция и т.п.)
            Consignee_City: null, // Получатель: населенный пункт
            Consignee_StreetHouse: null, // Получатель: улица, номер дома, номер офиса
            Consignee_IdentityCardCode: null, // Код вида документа, удостоверяющего личность
            Consignee_IdentityCardName: null, // Краткое наименование документа удостоверяющего личность
            Consignee_IdentityCardSeries: null, // Серия документа, удостоверяющего личность
            Consignee_IdentityCardNumber: null, // Номер документа, удостоверяющего личность
            Consignee_IdentityCardDate: null, // Дата выдачи документа, удостоверяющего личность
            Consignee_IdentityCardOrgName: null, // Наименование организации, выдавшей документ
            Consignee_INN: null, // Получатель: ИНН
            Consignee_KPP: null, // Получатель: 
            Consignee_OGRN: null, // Получатель:
            Carrier_INN: null, // Перевозчик: ИНН
            Carrier_OKPO: null, // Перевозчик: ОКПО
            Carrier_Name: null, // Перевозчик: Наименование
            Carrier_CountryCode: null, // Перевозчик: буквенный код страны
            Carrier_CountryName: null, // Перевозчик: наименование страны
            Carrier_PostalCode: null, // Перевозчик: почтовый индекс
            Carrier_Region: null, // Перевозчик: область (регион, штат, провинция и т.п.)
            Carrier_City: null, // Перевозчик: населенный пункт
            Carrier_StreetHouse: null, // Перевозчик: улица, номер дома, номер офиса
            Carrier_FactCountryCode: null, // Перевозчик: буквенный код страны
            Carrier_FactCountryName: null, // Перевозчик: наименование страны
            Carrier_FactPostalCode: null, // Перевозчик: почтовый индекс
            Carrier_FactRegion: null, // Перевозчик: область (регион, штат, провинция и т.п.)
            Carrier_FactCity: null, // Перевозчик: населенный пункт
            Carrier_FactStreetHouse: null, // Перевозчик: улица, номер дома, номер офиса
            CustomsBrokerCertificate: null, // Перевозчик: № свидетельства о включении в Реестр таможенных брокеров
            Carrier_Note: null, // Перевозчик: Дополнительные сведения
            Departure_IATACode: null, // Пункт отправления: ИАТА
            Departure_Name: null, // Пункт отправления: Наименование
            Departure_CountryCode: null, // Пункт отправления: Код страны
            Departure_CountryName: null, // Пункт отправления: наименование страны
            Departure_PostalCode: null, // Пункт отправления: почтовый индекс
            Departure_Region: null, // Пункт отправления: область (регион, штат, провинция и т.п.)
            Departure_City: null, // Пункт отправления: населенный пункт
            Departure_StreetHouse: null, // Пункт отправления: улица, номер дома, номер офиса
            Delivery_IATACode: null, // Пункт назначения: ИАТА
            Delivery_Name: null, // Пункт назначения: Наименование
            Delivery_CountryCode: null, // Пункт назначения: Код страны
            Delivery_CountryName: null, // Пункт назначения: наименование страны
            Delivery_PostalCode: null, // Пункт назначения: почтовый индекс
            Delivery_Region: null, // Пункт назначения: область (регион, штат, провинция и т.п.)
            Delivery_City: null, // Пункт назначения: населенный пункт
            Delivery_StreetHouse: null, // Пункт назначения: улица, номер дома, номер офиса
            Insurance_Amount: null, // Страхование: сумма
            Insurance_Account: null, // Страхование: Номер счёта
            Insurance_INN: null, // Страхование: инн
            Insurance_KPP: null, // Страхование: кпп
            Insurance_OGRN: null, // Страхование: огрн
            Insurance_OrgName: null, // Страхование: Наименование
            Insurance_PaymentType: null, // Страхование: вид оплаты
            WBEIGOODS: {
              WBEIGOODS_ITEM: [
                {
                  DOC_ID: null,
                  Receiver_Name: null,
                  Receiver_OGRN: null,
                  Receiver_INN: null,
                  Receiver_KPP: null,
                  CommonWayBillNum: null, // Номер общей накладной на товар
                  GoodsDescription: null,
                  TNVEDCode: null,
                  PlacesQuantity: null, // Общее кол-во грузовых мест 
                  PlacesPartQuantity: null, // Кол-во грузовых мест, частично занятых товаром
                  PackingTypeCode: null, // Код наличия упаковки товара
                  NetWeightQuantity: null,
                  GrossWeightQuantity: null,
                  DimensionsCode: null, // Код единицы измерения
                  Length: null,
                  Width: null,
                  Height: null,
                  InvoicedCost: null,
                  CustomsCost: null,
                  PaymentModeCode: null,
                  TaxBase: null, // основа начисления
                  PaymentAmount: null,
                  WBEIGOODSPALLETEINFO: {
                    WBEIGOODSPALLETEINFO_ITEM: [
                      {
                        DOC_ID: null,
                        InfoKindCode: null, // Кодовое обозначение вида информации ( 0 – сведения об упаковке;1 – сведения о таре;2 – сведения о грузе;3 – сведения о поддонах;4 – сведения об индивидуальной упаковке).
                        PalleteCode: null, // Код вида поддона в соответствии с классификатором видов груза, упаковки и упаковочных материалов
                        PalleteQuantity: null, // Количество поддонов
                        PalleteDescription: null, // Описание поддонов.
                        PackingMark: null
                      }
                    ]
                  }
                }
              ]
            }
        },
        collapseInsuranceVisible: false,
        insurancePaymentTypes: [
          { value: '1', text: 'Наличные' },
          { value: '2', text: 'Чек' },
          { value: '3', text: 'Кредитная карта' }
        ],        
        shipmentTypes: [
          { value: '1', text: 'Автомобильные перевозки' },
          { value: '2', text: 'Перевозки водным транспортом' },
          { value: '3', text: 'Авиаперевозки' }
        ],
        internationalDistributionTypes: [
          { value: "1", text: 'Используется' },
          { value: "0", text: 'Не используется' }
        ]
      }
    },
    watch: {
      waybill (val) {
        if (val) {
          this.waybillForm = Object.assign(this.waybillForm, val.data)
          this.waybillForm.did = val.did
          for (let key in this.waybillForm) {
            if ((key === 'ShipmentType') ||
                (key === 'RegDate') ||
                (key === 'RegTime') ||
                (key === 'CustomsModeCode') ||
                (key === 'CurrencyCode') ||
                (key === 'InternationalDistribution') ||
                (key === 'Consignor_CountryCode') ||
                (key === 'Consignor_CountryName') ||
                (key === 'Consignee_CountryCode') ||
                (key === 'Consignee_CountryName') ||
                (key === 'Consignee_IdentityCardDate') ||
                (key === 'Consignor_Region') ||
                (key === 'Consignee_Region') ||
                (key === 'Consignor_StreetHouse') ||
                (key === 'Consignee_StreetHouse') ||
                (key === 'URLShop') ||
                (key === 'Consignor_AddressInd') ||
                (key === 'Consignee_AddressInd') ||
                (key === 'Consignee_IdentityCardCode') ||
                (key === 'Consignee_IdentityCardName') ||
                (key === 'Consignee_FullIdentityCardName') ||
                (key === 'Carrier_CountryCode') ||
                (key === 'Carrier_CountryName') ||
                (key === 'Carrier_Region') ||
                (key === 'Carrier_StreetHouse') ||
                (key === 'Carrier_FactCountryCode') ||
                (key === 'Carrier_FactCountryName') ||
                (key === 'Carrier_FactRegion') ||
                (key === 'Carrier_FactStreetHouse') ||
                (key === 'Departure_CountryCode') ||
                (key === 'Departure_CountryName') ||
                (key === 'Departure_Region') ||
                (key === 'Departure_StreetHouse') ||
                (key === 'Delivery_CountryCode') ||
                (key === 'Delivery_CountryName') ||
                (key === 'Delivery_Region') ||
                (key === 'Delivery_StreetHouse') ||
                (key === 'Departure_Name') ||
                (key === 'Departure_IATACode') ||
                (key === 'Delivery_Name') ||
                (key === 'Delivery_IATACode') ||
                (key === 'Insurance_PaymentType')) {
                this.$refs[key].model = this.waybillForm[key]
            }
          }
        }
      },
      'waybillForm.Insurance_Amount' (val) { if (val && (val.length > 0)) this.collapseInsuranceVisible = true },
      'waybillForm.Insurance_Account' (val) { if (val && (val.length > 0)) this.collapseInsuranceVisible = true },
      'waybillForm.Insurance_INN' (val) { if (val && (val.length > 0)) this.collapseInsuranceVisible = true },
      'waybillForm.Insurance_KPP' (val) { if (val && (val.length > 0)) this.collapseInsuranceVisible = true },
      'waybillForm.Insurance_OGRN' (val) { if (val && (val.length > 0)) this.collapseInsuranceVisible = true },
      'waybillForm.Insurance_OrgName' (val) { if (val && (val.length > 0)) this.collapseInsuranceVisible = true },
      'waybillForm.Insurance_PaymentType' (val) { if (val && (val.length > 0)) this.collapseInsuranceVisible = true },
      'waybillForm.RegNum' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'HouseWaybill_DocumentNumber': newVal }) },
      'waybillForm.RegDate' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'HouseWaybill_DocumentDate': newVal, 'isCustom': true }) },
      'waybillForm.Consignor_Name' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignor_Name': newVal }) },
      'waybillForm.Consignor_INN' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignor_INN': newVal }) },
      'waybillForm.Consignor_KPP' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignor_KPP': newVal }) },
      'waybillForm.Consignor_OGRN' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignor_OGRN': newVal }) },
      'waybillForm.Consignor_CountryCode' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignor_CountryCode': newVal, 'isCustom': true }) },
      'waybillForm.Consignor_CountryName' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignor_CountryName': newVal, 'isCustom': true }) },
      'waybillForm.Consignor_PostalCode' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignor_PostalCode': newVal }) },
      'waybillForm.Consignor_Region' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignor_Region': newVal, 'isCustom': true }) },
      'waybillForm.Consignor_City' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignor_City': newVal }) },
      'waybillForm.Consignor_StreetHouse' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignor_StreetHouse': newVal, 'isCustom': true }) },
      'waybillForm.Consignee_Name' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_Name': newVal }) },
      'waybillForm.Consignee_INN' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_INN': newVal }) },
      'waybillForm.Consignee_CountryCode' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_CountryCode': newVal, 'isCustom': true }) },
      'waybillForm.Consignee_CountryName' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_CountryName': newVal, 'isCustom': true }) },
      'waybillForm.Consignee_PostalCode' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_PostalCode': newVal }) },
      'waybillForm.Consignee_Region' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_Region': newVal, 'isCustom': true }) },
      'waybillForm.Consignee_City' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_City': newVal }) },
      'waybillForm.Consignee_StreetHouse' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_StreetHouse': newVal, 'isCustom': true }) },
      'waybillForm.Consignee_IdentityCardCode' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_IdentityCardCode': newVal, 'isCustom': true }) },
      'waybillForm.Consignee_IdentityCardName' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_IdentityCardName': newVal, 'isCustom': true }) },
      'waybillForm.Consignee_IdentityCardSeries' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_IdentityCardSeries': newVal }) },
      'waybillForm.Consignee_IdentityCardNumber' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_IdentityCardNumber': newVal }) },
      'waybillForm.Consignee_IdentityCardDate' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_IdentityCardDate': newVal, 'isCustom': true }) },
      'waybillForm.Consignee_IdentityCardOrgName' (newVal, oldVal) { if (newVal !== oldVal) this.$emit('updateHsFields', { 'Consignee_OrganizationName': newVal }) },
    },
    computed: {
      ...mapState(
        {
          nsiProcedures: state => state.commissionShipment.nsiProcedures,
          nsiCurrency: state => state.houseShipment.nsiCurrency,
          nsiCountries: state => state.commissionShipment.nsiCountries,
          nsiIdentityDocuments: state => state.houseShipment.nsiIdentityDocuments,
          nsiAirports: state => state.houseShipment.nsiAirports,
        }
      )
    },
    mounted () {
      if (this.houseShipment) {
      for (let key in this.waybillForm) {
        switch (key) {
          case 'RegNum':
            if (!this.waybillForm.did && this.houseShipment.data.HouseWaybill_DocumentNumber)
              this.waybillForm.RegNum = this.houseShipment.data.HouseWaybill_DocumentNumber
            break
          case 'RegDate':
            if (!this.waybillForm.did && this.houseShipment.data.HouseWaybill_DocumentDate)
              this.$refs[key].model = this.waybillForm.RegDate = this.houseShipment.data.HouseWaybill_DocumentDate
            break
          case 'Consignor_Name':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.waybillForm.Consignor_Name = this.houseShipment.data[key]
            break
          case 'Consignor_INN':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.waybillForm.Consignor_INN = this.houseShipment.data[key]
            break
          case 'Consignor_KPP':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.waybillForm.Consignor_KPP = this.houseShipment.data[key]
            break
          case 'Consignor_OGRN':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.waybillForm.Consignor_OGRN = this.houseShipment.data[key]
            break
          case 'Consignor_CountryCode':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.$refs[key].model = this.waybillForm.Consignor_CountryCode = this.houseShipment.data[key]
            break
          case 'Consignor_CountryName':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.$refs[key].model = this.waybillForm.Consignor_CountryName = this.houseShipment.data[key]
            break
          case 'Consignor_PostalCode':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.waybillForm.Consignor_PostalCode = this.houseShipment.data[key]
            break
          case 'Consignor_Region':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.$refs[key].model = this.waybillForm.Consignor_Region = this.houseShipment.data[key]
            break
          case 'Consignor_City':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.waybillForm.Consignor_City = this.houseShipment.data[key]
            break
          case 'Consignor_StreetHouse':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.$refs[key].model = this.waybillForm.Consignor_StreetHouse = this.houseShipment.data[key]
            break
          case 'Consignee_Name':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.waybillForm.Consignee_Name = this.houseShipment.data[key]
            break
          case 'Consignee_INN':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.waybillForm.Consignee_INN = this.houseShipment.data[key]
            break
          case 'Consignee_CountryCode':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.$refs[key].model = this.waybillForm.Consignee_CountryCode = this.houseShipment.data[key]
            break
          case 'Consignee_CountryName':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.$refs[key].model = this.waybillForm.Consignee_CountryName = this.houseShipment.data[key]
            break
          case 'Consignee_PostalCode':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.waybillForm.Consignee_PostalCode = this.houseShipment.data[key]
            break
          case 'Consignee_Region':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.$refs[key].model = this.waybillForm.Consignee_Region = this.houseShipment.data[key]
            break
          case 'Consignee_City':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.waybillForm.Consignee_City = this.houseShipment.data[key]
            break
          case 'Consignee_StreetHouse':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.$refs[key].model = this.waybillForm.Consignee_StreetHouse = this.houseShipment.data[key]
            break
          case 'Consignee_IdentityCardCode':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.$refs[key].model = this.waybillForm.Consignee_IdentityCardCode = this.houseShipment.data[key]
            break
          case 'Consignee_IdentityCardName':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.$refs[key].model = this.waybillForm.Consignee_IdentityCardName = this.houseShipment.data[key]
            break
          case 'Consignee_IdentityCardSeries':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.waybillForm.Consignee_IdentityCardSeries = this.houseShipment.data[key]
            break
          case 'Consignee_IdentityCardNumber':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.waybillForm.Consignee_IdentityCardNumber = this.houseShipment.data[key]
            break
          case 'Consignee_IdentityCardDate':
            if (!this.waybillForm.did && this.houseShipment.data[key])
              this.$refs[key].model = this.waybillForm.Consignee_IdentityCardDate = this.houseShipment.data[key]
            break
          case 'Consignee_IdentityCardOrgName':
            if (!this.waybillForm.did && this.houseShipment.data.Consignee_OrganizationName)
              this.waybillForm.Consignee_IdentityCardOrgName = this.houseShipment.data.Consignee_OrganizationName
            break
          }
        }
      }
    },
    methods: {
      setModel (event) {
        this.waybillForm[event.fieldName] = event.item
        this.$nextTick(() => {
          this.updateIdbData()
        })
      },
      setRelated (event) {
        event.relatedFields.map((field) => {
          const key = Object.keys(field)[0]
          this.waybillForm[key] = event.item[field[key]]
          if (/^\d{4}-\d{2}-\d{2}$/.test(event.item[field[key]])) {
            let date = event.item[field[key]].split('-')
            date = date[2] + '.' + date[1] + '.' + date[0]
            this.$refs[key].model = date
          } else {
            this.$refs[key].model = event.item[field[key]]
          }
          return field
        })
        this.$nextTick(() => {
          this.updateIdbData()
        })
      },
      setVisible (event) {
        this.isRefVisible = event
      },
      updateIdbData () {
        this.$emit('updateWaybill')
      },
      resetFormData () {
        const props = Object.getOwnPropertyNames(this.waybillForm)
        for (let i = 0; i < props.length; i++) {
          this.waybillForm[props[i]] = null
          if (this.$refs[props[i]]) {
            this.$refs[props[i]].model = null
          }
        }
      },
      ...mapActions({
        loadNsiProcedures: 'commissionShipment/loadNsiProcedures',
        loadNsiCurrency: 'houseShipment/loadNsiCurrency',
        loadNsiCountries: 'commissionShipment/loadNsiCountries',
        loadNsiIdentityDocuments: 'houseShipment/loadNsiIdentityDocuments',
        loadNsiAirports: 'houseShipment/loadNsiAirports',
      })
    }
  }
</script>

<style lang="scss" scoped>
  .reset-file-btn {
    height: 28px;
  }
  .form-input-wrapper {
    position: relative !important;
    & .nsi-tooltips-wrapper {
      position: absolute;
      top: 36px;
      z-index: 10000;
      background-color: #ffffff;
      box-shadow: 0 4px 12px 0 rgb(0 0 0 / 30%);
      max-height: 200px;
      overflow-y: auto;
      overflow-x: hidden;
      & .fa-xmark {
        position: absolute;
        right: 10px;
        top: 10px;
        cursor: pointer;
        &:hover {
          color: #000000;
        }
      }
    }
  }
  .custom-invalid-feedback {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #e7161a;
  }
  hr {
    margin-top: 0 !important;
  }
</style>
